import {HISTORY_CONSTS, AUTH_CONSTS} from "../constants";


export const initialState = {
    bonusCardsHistory: {
        itemList: [],
        hasMore: false,
        startDate: undefined,
        endDate: undefined,
        type: undefined,
        text: ''
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case HISTORY_CONSTS.GET_HISTORY:
            return {
                ...state,
                bonusCardsHistory: {
                    itemsList: action.payload.reset ? action.payload.data : [...state.bonusCardsHistory.itemsList, ...action.payload.data],
                    text: action.payload.text,
                    type: action.payload.type,
                    startDate: action.payload.startDate,
                    endDate: action.payload.endDate,
                    hasMore: action.payload.hasMore
                }
            };


        case HISTORY_CONSTS.CLEAR_HISTORY:
        case AUTH_CONSTS.LOG_OUT:
            return initialState;
        default:
            return state;
    }
}
